import * as React from 'react';
import { t } from 'i18next';

import { BaseHamburgerTab } from './BaseHamburgerTab';
import { HamburgerTab, MessageBoxType } from '../../constants/Enums';
import { PersistentStore } from '../../stores/PersistentStore';
import { MailHelper } from '../../utils/MailHelper';
import { LayoutType } from '../../constants/LayoutConstants';
import { UrlHelper } from '../../utils/UrlHelper';
import { AppConfigurationStore } from '../../stores/AppConfigurationStore';
import { ViewSettingsStore } from '../../stores/ViewSettingsStore';
import { ViewSettingsActions } from '../../actions/ViewSettingsActions';
import { HamburgerContentWrapper } from './HamburgerContentWrapper';
import { LongButton } from '../LongButton';
import { PRODUCT_NAME } from '../../App';

interface HelpTabState {
    mailLink: string;
}
export class HelpTab extends BaseHamburgerTab<HelpTabState> {
    protected previous: HamburgerTab = HamburgerTab.MENU;

    public componentWillMount(): void {
        this.addStoreListener(PersistentStore, this.onChange);
        this.onChange();
    }

    public render(): JSX.Element {
        if (AppConfigurationStore.getState().inApp) {
            return (
                <HamburgerContentWrapper className={this.getCSSClass()} header={this.header()}>
                    <div className="long-button-group">
                        <LongButton
                            className="short-border with-arrow with-icon icon-info"
                            onClick={() => {ViewSettingsActions.changeHamburger(HamburgerTab.HELP_ICONS); }}
                        >
                            {t('Icons')}
                        </LongButton>
                    </div>
                </HamburgerContentWrapper>
            );
        }
        return (
            <HamburgerContentWrapper className={this.getCSSClass()} header={this.header()}>
                {this.linkContainer()}
            </HamburgerContentWrapper>
        );
    }

    protected onChange = (): void => {
        this.setState({ mailLink: MailHelper.getMailLink() });
    };

    protected getLabel(): string {
        return t('Help');
    }

    protected linkContainer: () => JSX.Element = () => {
        return (
            <div
                className="big-button-container"
                onClick={this.openLink}
            >
                <div className="big-button hand-button"/>
                <div className="big-button-text">{PRODUCT_NAME}&nbsp;{t('Help')}</div>
            </div>
        );
    };

    protected openLink = (): void => {
        const width: string = this.props.layoutType === LayoutType.DESKTOP ? '1025' : '800';
        window.open(
            UrlHelper.getExternalHelpLink(this.props.userLanguage),
            'Popup',
            `location=1,status=1,scrollbars=1, resizable=1, directories=1, toolbar=1, titlebar=1, width=${width}, height=800`
        );
    };

    /**
     * Will not work in app till its fixed there
     */
    protected openMail = (): void => {
        if (ViewSettingsStore.getBrowser() === 'Safari') {
            window.location.href = this.state.mailLink;
        } else {
            ViewSettingsActions.showMessage({
                wrap: false,
                element: <iframe style={{display: 'none'}} key={Date.now()} src={this.state.mailLink} width="1" height="1" frameBorder="0"/>,
                type: MessageBoxType.DEFAULT
            });
        }
    };
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/hamburgermenu/HelpTab.tsx